var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('VueLoading', _vm._b({}, 'VueLoading', _vm.loaderProps, false));

}
var staticRenderFns = []

export { render, staticRenderFns }